import React from "react";

// Catches render errors (incl. stale cached chunk/bundle issues after deploys)
// and auto-reloads once to fetch the fresh build. Shows a branded fallback otherwise.
export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error) {
    const msg = String(error?.message || error || "");
    const isChunkOrLoad = /ChunkLoadError|Loading chunk|Loading CSS chunk|Failed to fetch dynamically imported/i.test(msg);
    if (isChunkOrLoad && !sessionStorage.getItem("dna_reloaded")) {
      sessionStorage.setItem("dna_reloaded", "1");
      window.location.reload();
    }
  }

  render() {
    if (this.state.hasError) {
      return (
        <div style={{ minHeight: "100vh", background: "#050505", color: "#fff", display: "flex", alignItems: "center", justifyContent: "center", flexDirection: "column", gap: 20, fontFamily: "Manrope, sans-serif", padding: 24, textAlign: "center" }}>
          <img src="/dna-logo.png" alt="DNA Automotive" style={{ height: 56 }} />
          <p style={{ color: "#a1a1aa", maxWidth: 420 }}>
            Es gab ein kurzzeitiges Problem beim Laden. Bitte laden Sie die Seite neu.
          </p>
          <button
            onClick={() => { sessionStorage.removeItem("dna_reloaded"); window.location.href = "/"; }}
            style={{ background: "#2EE06B", color: "#050505", fontWeight: 700, textTransform: "uppercase", letterSpacing: "0.08em", padding: "14px 28px", border: "none", cursor: "pointer" }}
          >
            Seite neu laden
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}
